import QuickReplies from "../Nodes/QuickReplies";
import MediaNode from "../Nodes/WhatsApp/Media";
import WhatsappFlow from "../Nodes/WhatsApp/whatsappFlow";
import InteractiveCatalogue from "../Nodes/WhatsApp/InteractiveCatalogue";
import {
  AlphanumericNode,
  ButtonNode,
  CarouselNode,
  EmailNode,
  ImgFileNode,
  InteractiveCarouselNode,
  DateNode,
  InteractiveMessage,
  DelayComponent,
  InteractiveMessageList,
  LanguageNode,
  NameNode,
  NumberNode,
  OTPNode,
  PhoneNode,
  TextNode,
  TextfieldNode,
  InteractiveUrl,
  WhatsappTemplate,
} from "./../Nodes";
import LocationNode from "../Nodes/WhatsApp/Location";
import ShareLocationNode from "../Nodes/Location";

export const registerNodes: any = [
  {
    type: "start",
    name: "Hello",
    icon: "nodes",
    color: "#B8C4FF",
    isStart: true,
    category: null,
    displayComponent: null,
  },
  {
    type: "text",
    name: "Message",
    icon: "message",
    color: "#C8EF87",
    category: null,
    displayComponent: TextNode,
    supports: ["Web Bot", "whatsapp", "messenger", "telegram"],
  },
  {
    type: "name",
    name: "Name",
    icon: "user",
    category: "customer-details",
    color: "#BDD4FF",
    displayComponent: NameNode,
    supports: ["Web Bot", "whatsapp", "messenger", "telegram"],
  },
  {
    type: "phone-number",
    name: "Phone Number",
    icon: "phone",
    category: "customer-details",
    color: "#93E9C8",
    displayComponent: PhoneNode,
    childNodes: [
      {
        type: "otp",
        name: "OTP",
        icon: "otp",
        category: "customer-details",
        color: "#FFCC9C",
        displayComponent: OTPNode,
        parentNode: "phone-number",
      },
    ],
    supports: ["Web Bot", "messenger", "telegram"],
  },
  {
    type: "language",
    name: "Language",
    icon: "language",
    category: "customer-details",
    color: "#FFC0AC",
    displayComponent: LanguageNode,
    supports: ["Web Bot", "whatsapp", "messenger"],
  },
  {
    type: "email",
    name: "Email",
    icon: "email",
    category: "customer-details",
    color: "#FFB9C5",
    displayComponent: EmailNode,
    supports: ["Web Bot", "whatsapp", "messenger", "telegram"],
  },
  // {
  //   type: "article",
  //   name: "Article",
  //   icon: "article",
  //   category: "input-options",
  //   color: "#DFCBFF",
  //   displayComponent: ArticleNode,
  //   supports: ["Web Bot"],
  // },
  {
    type: "button",
    name: "Button",
    icon: "mouse",
    category: "input-options",
    color: "#FDDB84",
    displayComponent: ButtonNode,
    supports: ["Web Bot", "messenger", "telegram"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 3,
        charLimit: 20,
        descriptionLimit: 72,
      },
      messenger: {
        maxLimit: 3,
        charLimit: 20,
      },
    },
  },
  {
    type: "keyboard_button",
    name: "Keyboard Button",
    icon: "mouse",
    category: "input-options",
    color: "#FDDB84",
    displayComponent: ButtonNode,
    supports: ["telegram"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 3,
        charLimit: 20,
        descriptionLimit: 72,
      },
      messenger: {
        maxLimit: 3,
        charLimit: 20,
      },
    },
  },

  {
    type: "quick_replies",
    name: "Quick Actions",
    icon: "quickreply",
    category: "input-options",
    color: "#FDDB84",
    displayComponent: QuickReplies,
    supports: ["messenger"],
    validation: {
      web: {},
      whatsapp: {},
      messenger: {
        maxLimit: 13,
        charLimit: 20,
      },
    },
  },
  {
    type: "carousel",
    name: "Carousel",
    icon: "carousel",
    category: "input-options",
    color: "#B7D3FE",
    displayComponent: CarouselNode,
    supports: ["Web Bot", "messenger"],
  },
  {
    type: "alphanumeric",
    name: "Alphanumeric",
    icon: "alphanumeric",
    category: "input-options",
    color: "#FFD1AB",
    displayComponent: AlphanumericNode,
    supports: ["Web Bot", "whatsapp", "telegram"],
  },
  {
    type: "date",
    name: "Date",
    icon: "date",
    category: "input-options",
    color: "#EDEF8A",
    displayComponent: DateNode,
    supports: ["Web Bot"],
  },
  // {
  //   type: "feedback",
  //   name: "Feedback",
  //   icon: "feedback",
  //   category: "input-options",
  //   color: "#9DF8D7",
  //   displayComponent: FeedbackNode,
  //   supports: ["Web Bot", "whatsapp"],
  // },
  // {
  //   type: "dropdown",
  //   name: "Dropdown",
  //   icon: "dropdown",
  //   category: "input-options",
  //   color: "#91EAF5",
  //   displayComponent: DropdownNode,
  //   optionsLimit: null,
  //   supports: ["Web Bot", "whatsapp"],
  //   validation: {
  //     web: {},
  //     whatsapp: {
  //       maxLimit: 10,
  //     },
  //   },
  // },
  {
    type: "number",
    name: "Number",
    icon: "number",
    category: "input-options",
    color: "#ECB3DF",
    displayComponent: NumberNode,
    supports: ["Web Bot", "whatsapp", "telegram"],
  },
  {
    type: "img-file",
    name: "Img/File",
    icon: "file-attachment",
    category: "input-options",
    color: "#FFCC9C",
    displayComponent: ImgFileNode,
    allowedFiles: [
      {
        name: "Images",
        supportedExtensions: [
          {
            label: "jpg",
            value: "image/jpg",
          },
          {
            label: "jpeg",
            value: "image/jpeg",
          },
          {
            label: "doc",
            value: "application/msword",
          },
          {
            label: "xls",
            value: "application/vnd.ms-excel",
          },
          {
            label: "ppt",
            value: "application/vnd.ms-powerpoint",
          },
          {
            label: "pptx",
            value: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          },
          {
            label: "txt",
            value: "text/plain",
          },
          {
            label: "png",
            value: "image/png",
          }
          // {
          //   label: "svg",
          //   value: "image/svg+xml",
          // },
          // {
          //   label: "webp",
          //   value: "image/webp",
          // },
          // {
          //   label: "gif",
          //   value: "image/gif",
          // },
        ]
      },
      {
        name: "Audio",
        supportedExtensions: [
          {
            label: "mp3",
            value: "audio/mpeg",
          },
          {
            label: "wav",
            value: "audio/wav",
          },
        ],
      },
      {
        name: "Video",
        supportedExtensions: [
          {
            label: "mp4",
            value: "video/mp4",
          },
          {
            label: "webm",
            value: "video/webm",
          },
        ],
      },
      {
        name: "Documents",
        supportedExtensions: [
          {
            label: "pdf",
            value: "application/pdf",
          },
          {
            label: "docx",
            value:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          },
          {
            label: "xlsx",
            value:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          {
            label: "csv",
            value: "text/csv",
          },
        ],
      },
    ],
    supports: ["Web Bot", "whatsapp"],
  },
  // {
  //   type: "custom",
  //   name: "Custom",
  //   icon: "custom",
  //   category: "input-options",
  //   color: "#C3D1FF",
  //   displayComponent: CustomNode,
  //   supports: ["Web Bot", "whatsapp", "messenger"],
  // },
  {
    type: "textfield",
    name: "Textfield",
    icon: "text-field",
    category: "input-options",
    color: "#9AE2B2",
    displayComponent: TextfieldNode,
    supports: ["Web Bot", "whatsapp", "messenger", "telegram"],
  },
  // {
  //   type: "time",
  //   name: "Time",
  //   icon: "time",
  //   category: "input-options",
  //   color: "#D6F1AA",
  //   displayComponent: TimeNode,
  //   supports: ["Web Bot"],
  // },
  {
    type: "interactive-message",
    name: "Interactive Message",
    icon: "message",
    color: "#C8EF87",
    category: null,
    displayComponent: InteractiveMessage,
    supports: ["whatsapp"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 3,
        charLimit: 20,
        headerMaxLimit: 60,
        bodyMaxLimit: 1024,
        footerMaxLimit: 20,
        descriptionLimit: 72,
      },
    },
  },
  {
    type: "interactive-message-list",
    name: "Interactive Message List",
    icon: "message",
    color: "#C8EF87",
    category: null,
    displayComponent: InteractiveMessageList,
    supports: ["whatsapp"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 10,
        charLimit: 20,
        headerMaxLimit: 60,
        bodyMaxLimit: 1024,
        footerMaxLimit: 20,
        buttonLabelMaxLimit: 20,
        descriptionLimit: 72,
      },
    },
  },
  {
    type: "whatsapp-template",
    name: "Whatsapp Template",
    icon: "message",
    color: "#C8EF87",
    category: null,
    displayComponent: WhatsappTemplate,
    supports: ["whatsapp"],
  },
  {
    type: "flow-list",
    name: "Whatsapp flow",
    icon: "message",
    color: "#C8EF87",
    category: null,
    displayComponent: WhatsappFlow,
    supports: ["whatsapp"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 10,
        charLimit: 20,
        headerMaxLimit: 60,
        bodyMaxLimit: 1024,
        footerMaxLimit: 20,
        buttonLabelMaxLimit: 20,
        descriptionLimit: 72,
      },
    },
  },
  {
    type: "whatsapp-catalogue",
    name: "Whatsapp Catalogue",
    icon: "message",
    color: "#C8EF87",
    category: null,
    displayComponent: InteractiveCatalogue,
    supports: ["whatsapp"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 10,
        charLimit: 20,
        headerMaxLimit: 60,
        bodyMaxLimit: 1024,
        footerMaxLimit: 20,
        buttonLabelMaxLimit: 20,
        descriptionLimit: 72,
      },
    },
  },
  {
    type: "interactive-button-url",
    name: "Interactive URL",
    icon: "url",
    color: "#C8EF87",
    category: null,
    displayComponent: InteractiveUrl,
    supports: ["whatsapp"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 10,
        charLimit: 20,
        headerMaxLimit: 60,
        bodyMaxLimit: 1024,
        footerMaxLimit: 20,
        buttonLabelMaxLimit: 20,
        descriptionLimit: 72,
      },
    },
  },
  {
    type: "delay",
    name: "Delay",
    icon: "time",
    color: "#D6F1AA",
    category: null,
    displayComponent: DelayComponent,
    supports: ["whatsapp"],
    validation: {
      web: {},
      whatsapp: {
        maxLimit: 10,
        charLimit: 20,
        headerMaxLimit: 60,
        bodyMaxLimit: 1024,
        footerMaxLimit: 20,
        buttonLabelMaxLimit: 20,
        descriptionLimit: 72,
      },
    },
  },
  {
    type: "location-node",
    name: "Location",
    icon: "gps_fixed",
    color: "#C8EF87",
    category: "customer-details",
    displayComponent: LocationNode,
    supports: ["whatsapp"]
  },
  {
    type: "share-location",
    name: "Share Location",
    icon: "compass",
    category: null,
    color: "#C8EF87",
    displayComponent: ShareLocationNode,
    supports: ["whatsapp"]
  },
  {
    type: "media",
    name: "Media",
    icon: "file-attachment",
    category: null,
    color: "#FFCC9C",
    displayComponent: MediaNode,
    allowedFiles: [
      {
        name: "Images",
        supportedExtensions: [
          {
            label: "jpg/jpeg",
            value: "image/jpeg",
          },
          {
            label: "png",
            value: "image/png",
          },
          {
            label: "svg",
            value: "image/svg+xml",
          },
          {
            label: "webp",
            value: "image/webp",
          },
          {
            label: "gif",
            value: "image/gif",
          },
        ],
      },
      {
        name: "Documents",
        supportedExtensions: [
          {
            label: "pdf",
            value: "application/pdf",
          },
          {
            label: "docx",
            value:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          },
          {
            label: "xlsx",
            value:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          {
            label: "csv",
            value: "text/csv",
          },
        ],
      },
    ],
    supports: ["whatsapp"],
  },
  // {
  //   type: "whatsapp-carousel",
  //   name: "Whatsapp Carousel",
  //   icon: "carousel",
  //   category: null,
  //   color: "#C8EF87",
  //   displayComponent: InteractiveCarouselNode,
  //   supports: ["whatsapp"],
  //   validation: {
  //     web: {},
  //     whatsapp: {
  //       maxLimit: 2,
  //       charLimit: 20,
  //       headerMaxLimit: 60,
  //       bodyMaxLimit: 1024,
  //       footerMaxLimit: 20,
  //       buttonLabelMaxLimit: 20,
  //       descriptionLimit: 72,
  //     },
  //   },
  // },
];
